var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgStarOutline = function SvgStarOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "star-outline_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarOutline);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;